(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["miami-collection-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-miami-collection-hero]').forEach((hero) => {
    const gallery = hero.querySelector('[data-project-gallery]');
    if (!gallery || gallery.dataset.ready === 'true') return;
    gallery.dataset.ready = 'true';
    const cards = Array.from(gallery.querySelectorAll('.mnc-card'));
    const previous = hero.querySelector('[data-gallery-prev]');
    const next = hero.querySelector('[data-gallery-next]');
    const count = hero.querySelector('[data-gallery-count]');
    const position = (card) => card.offsetLeft - cards[0].offsetLeft;
    const current = () => cards.reduce((best, card, i) => Math.abs(position(card) - gallery.scrollLeft) < Math.abs(position(cards[best]) - gallery.scrollLeft) ? i : best, 0);
    const update = () => {
      if (!cards.length) return;
      const atEnd = gallery.scrollLeft >= gallery.scrollWidth - gallery.clientWidth - 2;
      previous.disabled = gallery.scrollLeft <= 2;
      next.disabled = atEnd;
      if (count) count.textContent = `${atEnd ? cards.length : current() + 1} / ${cards.length}`;
    };
    const move = (direction) => {
      const index = Math.max(0, Math.min(cards.length - 1, current() + direction));
      gallery.scrollTo({ left: position(cards[index]), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    gallery.addEventListener('scroll', update, { passive: true });
    gallery.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      move(event.key === 'ArrowRight' ? 1 : -1);
    });
    window.addEventListener('resize', update, { passive: true });
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miami-podcast-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-miami-collection-hero]').forEach((hero) => {
    const gallery = hero.querySelector('[data-project-gallery]');
    if (!gallery || gallery.dataset.ready === 'true') return;
    gallery.dataset.ready = 'true';
    const cards = Array.from(gallery.querySelectorAll('.mnc-card'));
    const previous = hero.querySelector('[data-gallery-prev]');
    const next = hero.querySelector('[data-gallery-next]');
    const count = hero.querySelector('[data-gallery-count]');
    const position = (card) => card.offsetLeft - cards[0].offsetLeft;
    const current = () => cards.reduce((best, card, i) => Math.abs(position(card) - gallery.scrollLeft) < Math.abs(position(cards[best]) - gallery.scrollLeft) ? i : best, 0);
    const update = () => {
      if (!cards.length) return;
      const atEnd = gallery.scrollLeft >= gallery.scrollWidth - gallery.clientWidth - 2;
      previous.disabled = gallery.scrollLeft <= 2;
      next.disabled = atEnd;
      if (count) count.textContent = `${atEnd ? cards.length : current() + 1} / ${cards.length}`;
    };
    const move = (direction) => {
      const index = Math.max(0, Math.min(cards.length - 1, current() + direction));
      gallery.scrollTo({ left: position(cards[index]), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    gallery.addEventListener('scroll', update, { passive: true });
    gallery.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      move(event.key === 'ArrowRight' ? 1 : -1);
    });
    window.addEventListener('resize', update, { passive: true });
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miami-redesign-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('.mnr-hero-carousel').forEach((carousel) => {
    const track = carousel.querySelector('[data-mnr-hero-track]');
    const slides = track ? Array.from(track.querySelectorAll('.mnr-hero-slide')) : [];
    const pause = carousel.querySelector('[data-mnr-hero-pause]');
    if (!track || slides.length < 2) return;
    const photoKey = slide => (slide.querySelector('img')?.getAttribute('src') || '').split('?')[0];
    for (let i = slides.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [slides[i], slides[j]] = [slides[j], slides[i]];
    }
    try {
      const previous = localStorage.getItem('mn-hero-last-photo');
      if (photoKey(slides[0]) === previous) {
        const next = 1 + Math.floor(Math.random() * (slides.length - 1));
        [slides[0], slides[next]] = [slides[next], slides[0]];
      }
      localStorage.setItem('mn-hero-last-photo', photoKey(slides[0]));
    } catch {}
    slides.forEach(slide => track.appendChild(slide));
    track.scrollTo({left:0, behavior:'instant'});
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let timer, paused = false, hovered = false, focused = false, touched = false, visible = false;
    const currentIndex = () => slides.reduce((best, slide, i) => Math.abs(slide.offsetLeft - slides[0].offsetLeft - track.scrollLeft) < Math.abs(slides[best].offsetLeft - slides[0].offsetLeft - track.scrollLeft) ? i : best, 0);
    const move = (direction) => {const i = (currentIndex() + direction + slides.length) % slides.length;track.scrollTo({left:slides[i].offsetLeft - slides[0].offsetLeft, behavior:motion.matches ? 'auto' : 'smooth'});};
    const stop = () => {clearInterval(timer);timer = null;};
    const start = () => {stop();if (!paused && !motion.matches && !hovered && !focused && !touched && visible && !document.hidden) timer = setInterval(() => move(1),3500);};
    carousel.querySelector('[data-mnr-hero-prev]')?.addEventListener('click',()=>{move(-1);start();});
    carousel.querySelector('[data-mnr-hero-next]')?.addEventListener('click',()=>{move(1);start();});
    pause?.addEventListener('click',()=>{paused=!paused;pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-label',paused?pause.dataset.playLabel:pause.dataset.pauseLabel);start();});
    carousel.addEventListener('mouseenter',()=>{hovered=true;stop();});
    carousel.addEventListener('mouseleave',()=>{hovered=false;start();});
    carousel.addEventListener('focusin',()=>{focused=true;stop();});
    carousel.addEventListener('focusout',()=>{setTimeout(()=>{focused=carousel.contains(document.activeElement);start();},0);});
    carousel.addEventListener('touchstart',()=>{touched=true;stop();},{passive:true});
    carousel.addEventListener('touchend',()=>{touched=false;start();},{passive:true});
    carousel.addEventListener('touchcancel',()=>{touched=false;start();},{passive:true});
    document.addEventListener('visibilitychange',start);
    motion.addEventListener('change',start);
    new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;start();},{threshold:.2}).observe(carousel);
  });
})();


(() => {
  const init = () => document.querySelectorAll('[data-mn-anatomy]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const controls = root.querySelectorAll('[data-mn-part]');
    controls.forEach((button) => button.addEventListener('click', () => {
      const part = button.dataset.mnPart;
      controls.forEach((control) => control.setAttribute('aria-pressed', String(control.dataset.mnPart === part)));
      root.querySelectorAll('[data-mn-part-panel]').forEach((panel) => { panel.hidden = panel.dataset.mnPartPanel !== part; });
    }));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();

(() => {
  const init = () => document.querySelectorAll('[data-mn-reviews]').forEach((root) => {
    if (root.dataset.reviewReady) return;
    root.dataset.reviewReady = 'true';
    const track = root.querySelector('[data-mn-review-track]');
    const cards = Array.from(root.querySelectorAll('[data-mn-review-card]'));
    const prev = root.querySelector('[data-mn-review-prev]');
    const next = root.querySelector('[data-mn-review-next]');
    const counter = root.querySelector('[data-mn-review-counter]');
    if (!track || !cards.length) return;
    let pending = false;
    const index = () => {
      const left = track.getBoundingClientRect().left;
      let selected = 0, distance = Infinity;
      cards.forEach((card, i) => {
        const delta = Math.abs(card.getBoundingClientRect().left - left);
        if (delta < distance) { distance = delta; selected = i; }
      });
      return selected;
    };
    const update = () => {
      const current = index();
      prev.disabled = track.scrollLeft < 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      counter.textContent = counter.dataset.label.replace('[current]', current + 1).replace('[total]', cards.length);
    };
    const move = (direction) => {
      const target = cards[Math.max(0, Math.min(cards.length - 1, index() + direction))];
      const left = target.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      track.scrollTo({ left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('keydown', (event) => {
      if (event.target !== track) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
    });
    track.addEventListener('scroll', () => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { update(); pending = false; });
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();


(() => {
  const dialog=document.querySelector('[data-mn-photo-dialog]');
  if(!dialog)return;
  const image=dialog.querySelector('[data-mn-photo-full]'),stage=dialog.querySelector('[data-mn-photo-stage]'),level=dialog.querySelector('[data-mn-zoom-level]');
  const buttons=[...document.querySelectorAll('[data-mn-photo-open]')];let index=0,zoom=1;
  const setZoom=(value)=>{zoom=Math.max(1,Math.min(3,value));stage.style.setProperty('--mn-zoom',zoom);level.textContent=Math.round(zoom*100)+'%';dialog.querySelector('[data-mn-zoom-out]').disabled=zoom===1;dialog.querySelector('[data-mn-zoom-in]').disabled=zoom===3;if(zoom===1)stage.scrollTo(0,0);};
  const show=(i)=>{index=(i+buttons.length)%buttons.length;const source=buttons[index].querySelector('img');image.src=source.src;image.alt=source.alt;image.width=source.naturalWidth||source.width;image.height=source.naturalHeight||source.height;dialog.querySelector('[data-mn-photo-caption]').textContent=buttons[index].closest('figure').querySelector('figcaption').textContent;setZoom(1);};
  buttons.forEach((button,i)=>button.addEventListener('click',()=>{show(i);dialog.showModal();}));
  dialog.querySelector('[data-mn-photo-close]').addEventListener('click',()=>dialog.close());
  dialog.querySelector('[data-mn-view-prev]').addEventListener('click',()=>show(index-1));
  dialog.querySelector('[data-mn-view-next]').addEventListener('click',()=>show(index+1));
  dialog.querySelector('[data-mn-zoom-out]').addEventListener('click',()=>setZoom(zoom-.5));
  dialog.querySelector('[data-mn-zoom-in]').addEventListener('click',()=>setZoom(zoom+.5));
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
  dialog.addEventListener('keydown',event=>{if(event.target===stage&&zoom>1)return;if(event.key==='ArrowRight'){event.preventDefault();show(index+1);}if(event.key==='ArrowLeft'){event.preventDefault();show(index-1);}if(event.key==='+'||event.key==='='){event.preventDefault();setZoom(zoom+.5);}if(event.key==='-'){event.preventDefault();setZoom(zoom-.5);}});
  document.querySelectorAll('[data-mn-photo-gallery]').forEach(gallery=>{
    const track=gallery.querySelector('[data-mn-photo-track]'),prev=gallery.querySelector('[data-mn-photo-prev]'),next=gallery.querySelector('[data-mn-photo-next]');
    const update=()=>{prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;};
    const move=d=>track.scrollBy({left:d*(track.querySelector('figure').getBoundingClientRect().width+16),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
    track.addEventListener('keydown',event=>{if(event.target!==track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
    track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);update();
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miami-trending-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-miami-collection-hero]').forEach((hero) => {
    const gallery = hero.querySelector('[data-project-gallery]');
    if (!gallery || gallery.dataset.ready === 'true') return;
    gallery.dataset.ready = 'true';
    const cards = Array.from(gallery.querySelectorAll('.mnc-card'));
    const previous = hero.querySelector('[data-gallery-prev]');
    const next = hero.querySelector('[data-gallery-next]');
    const count = hero.querySelector('[data-gallery-count]');
    const position = (card) => card.offsetLeft - cards[0].offsetLeft;
    const current = () => cards.reduce((best, card, i) => Math.abs(position(card) - gallery.scrollLeft) < Math.abs(position(cards[best]) - gallery.scrollLeft) ? i : best, 0);
    const update = () => {
      if (!cards.length) return;
      const atEnd = gallery.scrollLeft >= gallery.scrollWidth - gallery.clientWidth - 2;
      previous.disabled = gallery.scrollLeft <= 2;
      next.disabled = atEnd;
      if (count) count.textContent = `${atEnd ? cards.length : current() + 1} / ${cards.length}`;
    };
    const move = (direction) => {
      const index = Math.max(0, Math.min(cards.length - 1, current() + direction));
      gallery.scrollTo({ left: position(cards[index]), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    gallery.addEventListener('scroll', update, { passive: true });
    gallery.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      move(event.key === 'ArrowRight' ? 1 : -1);
    });
    window.addEventListener('resize', update, { passive: true });
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-email-signup-popup"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
  const dialog = document.querySelector('[data-mn-signup]');
  if (!dialog || dialog.dataset.mnInitialized === 'true') return;
  dialog.dataset.mnInitialized = 'true';
  const trigger = document.querySelector('[data-mn-signup-open]');
  const emailCard = dialog.querySelector('[data-mn-email-card]');
  const chainCard = document.querySelector('[data-mnr-chain-popup]');
  const chainHost = dialog.querySelector('[data-mn-chain-host]');
  if (chainCard && chainHost) chainHost.appendChild(chainCard);
  const subscribedKey = 'miami-neons-email-subscribed';
  let previousFocus;
  let popupTimer;
  const read = (key) => { try { return localStorage.getItem(key); } catch { return null; } };
  const write = (key, value) => { try { localStorage.setItem(key, value); } catch {} };
  const success = dialog.querySelector('[data-mn-signup-success]');
  const errors = dialog.querySelector('[data-mn-signup-error]');
  const subscribed = read(subscribedKey) === 'true';
  if (trigger && (!emailCard || subscribed || success)) trigger.hidden = true;
  const closeIfEmpty = () => {
    if ((!emailCard || emailCard.hidden) && (!chainCard || chainCard.hidden)) { dialog.close(); return; }
    const activeCard = emailCard && !emailCard.hidden ? emailCard : chainCard;
    activeCard?.querySelector('button, a, input')?.focus();
  };
  const closeEmail = () => { if (emailCard) emailCard.hidden = true; clearTimeout(popupTimer); closeIfEmpty(); };
  const closeChain = () => { if (chainCard) chainCard.hidden = true; clearTimeout(popupTimer); closeIfEmpty(); };
  const closeAll = () => { clearTimeout(popupTimer); if (emailCard) emailCard.hidden = true; if (chainCard) chainCard.hidden = true; if (dialog.open) dialog.close(); };
  const open = (showEmail, showChain) => {
    if (emailCard) emailCard.hidden = !showEmail;
    if (chainCard) chainCard.hidden = !showChain;
    if (!(emailCard && showEmail) && !(chainCard && showChain)) return;
    previousFocus = document.activeElement;
    if (!dialog.open) dialog.showModal();
    clearTimeout(popupTimer);
    dialog.scrollTop = 0;
  };
  emailCard?.querySelectorAll('[data-mn-signup-close]').forEach((button) => button.addEventListener('click', closeEmail));
  chainCard?.querySelector('[data-mnr-chain-close]')?.addEventListener('click', closeChain);
  trigger?.addEventListener('click', () => open(Boolean(emailCard) && !subscribed, Boolean(chainCard)));
  dialog.querySelector('[data-mn-close-all]')?.addEventListener('click', closeAll);
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); closeAll(); });
  dialog.addEventListener('close', () => { previousFocus?.focus(); });
  dialog.addEventListener('click', (event) => {
    const box = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) closeAll();
  });
  if (success) { write(subscribedKey, 'true'); open(true, false); return; }
  if (errors) { open(true, false); return; }
  if (emailCard) emailCard.hidden = true;
  if (chainCard) chainCard.hidden = true;
  const showEmail = Boolean(emailCard) && !subscribed;
  const showChain = Boolean(chainCard);
  const delay = Math.max(0, 6000 - performance.now());
  if (showEmail || showChain) popupTimer = setTimeout(() => open(showEmail, showChain), delay);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-fan-chain-quote"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-mnfc]');
  if (!root) return;

  const state = {
    fan_chain_for: '',
    pendant_style: '',
    quantity: '',
    chain_color: '',
    approx_size: '',
    deadline: ''
  };

  const attachHidden = () => {
    const form = root.querySelector('.globo-formbuilder form') || root.querySelector('.mnfc-app form');
    if (!form) return;
    Object.entries(state).forEach(([key, value]) => {
      let input = form.querySelector('[data-mnfc-hidden="' + key + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.dataset.mnfcHidden = key;
        form.appendChild(input);
      }
      input.value = value;
    });
    let context = form.querySelector('[data-mnfc-hidden="product_context"]');
    if (!context) {
      context = document.createElement('input');
      context.type = 'hidden';
      context.name = 'product_context';
      context.dataset.mnfcHidden = 'product_context';
      form.appendChild(context);
    }
    context.value = 'Custom LED Neon Fan Chain';
  };

  const updateButtons = () => {
    const step1 = root.querySelector('[data-mnfc-step="1"] .mnfc-next');
    const step2 = root.querySelector('[data-mnfc-step="2"] .mnfc-next');
    if (step1) step1.disabled = !(state.fan_chain_for && state.pendant_style);
    if (step2) step2.disabled = !(state.quantity && state.chain_color);
  };

  const showStep = (step) => {
    root.querySelectorAll('[data-mnfc-step]').forEach((node) => {
      node.classList.toggle('is-active', node.dataset.mnfcStep === String(step));
    });
    root.querySelectorAll('[data-mnfc-dot]').forEach((node) => {
      node.classList.toggle('is-active', Number(node.dataset.mnfcDot) <= Number(step));
    });
    if (Number(step) === 3) {
      const summary = root.querySelector('[data-mnfc-summary]');
      if (summary) {
        summary.innerHTML = Object.values(state).filter(Boolean).map((value) => '<span>' + value + '</span>').join('');
      }
      attachHidden();
    }
  };

  root.querySelectorAll('[data-mnfc-choice]').forEach((group) => {
    group.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        group.querySelectorAll('button').forEach((item) => item.classList.remove('is-selected'));
        button.classList.add('is-selected');
        state[group.dataset.mnfcChoice] = button.dataset.value;
        updateButtons();
        attachHidden();
      });
    });
  });

  root.querySelectorAll('[data-mnfc-input]').forEach((input) => {
    input.addEventListener('input', () => {
      state[input.dataset.mnfcInput] = input.value;
      attachHidden();
    });
  });

  root.querySelectorAll('[data-mnfc-next]').forEach((button) => {
    button.addEventListener('click', () => showStep(button.dataset.mnfcNext));
  });

  const app = root.querySelector('.mnfc-app');
  if (app) {
    const observer = new MutationObserver(attachHidden);
    observer.observe(app, { childList: true, subtree: true });
  }
  updateButtons();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-launch-and-videos"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    document.querySelectorAll('[data-mn-launch]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const saveData = navigator.connection?.saveData === true;
      const connection = navigator.connection?.effectiveType || '';
      const slowConnection = connection === 'slow-2g' || connection === '2g' || connection === '3g';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const cards = Array.from(root.querySelectorAll('[data-mn-video-card]'));

      const hydrate = (video) => {
        if (!video || video.dataset.hydrated === 'true') return;
        const source = video.querySelector('source[data-src]');
        if (!source?.dataset.src) return;
        source.src = source.dataset.src;
        video.dataset.hydrated = 'true';
        video.load();
      };

      cards.forEach((card,index) => {
        const video = card.querySelector('[data-mn-video]');
        const play = card.querySelector('[data-mn-play]');
        const warning = card.querySelector('[data-mn-video-error]');
        if (!video || !play) return;

        const showError = () => {
          warning.hidden = false;
          play.hidden = false;
        };

        play.addEventListener('click', () => {
          hydrate(video);
          video.muted = false;
          warning.hidden = true;
          play.hidden = true;
          video.play().catch(showError);
        });

        video.addEventListener('error',showError);
        video.addEventListener('playing',() => {
          warning.hidden = true;
          play.hidden = true;
        });

        video.addEventListener('pause',() => {
          if (!video.ended && video.currentTime < 0.5) play.hidden = false;
        });

        video.addEventListener('play',() => {
          cards.forEach((otherCard) => {
            const other = otherCard.querySelector('[data-mn-video]');
            if (other && other !== video) other.pause();
          });
        });

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                if (!video.paused) video.pause();
                return;
              }

              if (index === 0 && !saveData && !slowConnection && !reducedMotion) {
                hydrate(video);
                video.muted = true;
                video.loop = true;
                video.play().catch(() => {
                  play.hidden = false;
                });
              }
            });
          }, {rootMargin:'500px 0px',threshold:0.2});

          observer.observe(card);
        }
      });

      document.querySelectorAll('.mnr-home img[loading="lazy"]').forEach((image) => {
        image.fetchPriority = 'low';
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();

  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-mobile-quote-popup"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    const card = document.querySelector('[data-mn-mobile-quote]');
    if (!card || card.dataset.initialized === 'true') return;
    card.dataset.initialized = 'true';
    const mobile = window.matchMedia('(max-width:767px)');
    const params = new URLSearchParams(location.search);
    const preview = params.get('mn_quote_preview') === '1' && card.dataset.themeRole === 'unpublished';
    const key = 'mn-mobile-quote-seen-v1';
    let previouslySeen = false;
    try { previouslySeen = sessionStorage.getItem(key) === '1'; } catch {}
    let dismissed = previouslySeen && !preview;
    let firstShown = false;
    let timer;
    const started = Date.now();
    const delay = Math.max(8, Number(card.dataset.delay) || 18) * 1000;
    let quietUntil = 0;
    const visible = node => {
      if (!node || node.closest('[hidden]')) return false;
      const box = node.getBoundingClientRect();
      const style = getComputedStyle(node);
      return box.width > 0 && box.height > 0 && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0;
    };
    const hide = () => {
      if (!card.hidden) card.hidden = true;
      document.body.classList.remove('mn-mobile-quote-open');
    };
    const dismiss = () => {
      dismissed = true;
      clearTimeout(timer);
      const restoreFocus = card.contains(document.activeElement);
      hide();
      if (!preview) { try { sessionStorage.setItem(key, '1'); } catch {} }
      if (restoreFocus) {
        const main = document.getElementById('MainContent');
        if (main) {
          const oldTabindex = main.getAttribute('tabindex');
          main.setAttribute('tabindex', '-1');
          main.focus({preventScroll:true});
          if (oldTabindex === null) main.removeAttribute('tabindex');
          else main.setAttribute('tabindex', oldTabindex);
        }
      }
    };
    const otherOverlay = () => [...document.querySelectorAll('dialog[open], [aria-modal="true"], .m-search-popup, .m-cookie-banner, #shopify-pc__banner')].some(node => node !== card && visible(node));
    const editing = () => document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
    const update = () => {
      clearTimeout(timer);
      if (dismissed) { hide(); return; }
      if (!mobile.matches) { hide(); return; }
      if (preview) document.querySelector('dialog[data-mn-signup][open]')?.close();
      if (document.hidden || otherOverlay() || editing()) {
        hide();
        quietUntil = Date.now() + 3000;
      } else if ((preview || Date.now() - started >= delay) && Date.now() >= quietUntil) {
        card.hidden = false;
        document.body.classList.add('mn-mobile-quote-open');
        if (!firstShown) {
          firstShown = true;
          if (!preview) { try { sessionStorage.setItem(key, '1'); } catch {} }
        }
      }
      if (firstShown || Date.now() - started < 300000) timer = setTimeout(update, 800);
    };
    card.querySelector('[data-mnmq-close]').addEventListener('click', dismiss);
    const quote = card.querySelector('[data-mnmq-quote]');
    if (params.has('preview_theme_id')) {
      const url = new URL(quote.href);
      url.searchParams.set('preview_theme_id', params.get('preview_theme_id'));
      quote.href = url.pathname + url.search;
    }
    quote.addEventListener('click', () => {
      dismissed = true;
      clearTimeout(timer);
      hide();
      if (!preview) { try { sessionStorage.setItem(key, '1'); } catch {} }
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !card.hidden && !otherOverlay()) dismiss();
    });
    if (mobile.addEventListener) mobile.addEventListener('change', update);
    else mobile.addListener(update);
    document.addEventListener('visibilitychange', update);
    window.addEventListener('pagehide', () => {clearTimeout(timer);hide();});
    window.addEventListener('pageshow', update);
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-showcase-playback"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.mnShowcasePlaybackV3) {
    window.mnShowcasePlaybackV3.init();
    return;
  }
  const instances = new Map();
  const preferenceKey = 'mn-showcase-muted-v1';
  const savedMute = () => {
    try { return sessionStorage.getItem(preferenceKey) === '1'; } catch (_) { return false; }
  };
  const saveMute = muted => {
    try { sessionStorage.setItem(preferenceKey, muted ? '1' : '0'); } catch (_) {}
  };
  function mount(video, config) {
    const shell = video.closest('.mnr-workshop__video');
    if (!shell || instances.has(video)) return;
    const events = new AbortController();
    const on = (target, name, fn, options = {}) => target.addEventListener(name, fn, {...options, signal:events.signal});
    const button = config.content.querySelector('button').cloneNode(true);
    const label = button.querySelector('[data-sound-text]');
    const wave = button.querySelector('[data-sound-wave]');
    const slash = button.querySelector('[data-sound-slash]');
    const description = document.createElement('span');
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    let requestId = 0;
    let hasHeardSound = false;
    let wantsSound = !savedMute();
    let pausedByUser = false;
    let pausedByOther = false;
    let resumeWhenVisible = false;
    let frame = 0;
    let destroyed = false;
    video.dataset.mnPrimed = 'true';
    video.id = video.id || config.dataset.id;
    video.controls = false;
    video.removeAttribute('controls');
    video.autoplay = false;
    video.removeAttribute('autoplay');
    video.preload = 'auto';
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.disablePictureInPicture = true;
    video.setAttribute('disablepictureinpicture', '');
    video.loop = true;
    video.tabIndex = 0;
    video.pause();
    description.id = video.id + '-help';
    description.className = 'mn-showcase-sr';
    description.textContent = config.dataset.help;
    video.setAttribute('aria-describedby', description.id);
    button.setAttribute('aria-controls', video.id);
    shell.dataset.mnPlayback = 'true';
    shell.append(description, button);

    function position() {
      frame = 0;
      if (destroyed) return;
      const rect = shell.getBoundingClientRect();
      const inView = rect.bottom > 80 && rect.top < innerHeight - 50;
      const floating = !inView && !video.paused && !video.muted;
      button.classList.toggle('is-floating', floating);
      if (!floating) return;
      let top = 12;
      document.querySelectorAll('header,.m-header,[data-sticky-header]').forEach(header => {
        const box = header.getBoundingClientRect();
        if (box.width > 0 && box.height > 0 && box.height < 250 && box.top < 80 && box.bottom > 0) top = Math.max(top, box.bottom + 10);
      });
      button.style.setProperty('--mn-sound-top', Math.min(top, innerHeight - 60) + 'px');
    }
    function queuePosition() { if (!frame) frame = requestAnimationFrame(position); }
    function update() {
      if (destroyed) return;
      const audible = !video.muted && !video.paused;
      const text = video.paused ? config.dataset.play : video.muted ? config.dataset.on : config.dataset.off;
      if (label.textContent !== text) label.textContent = text;
      button.setAttribute('aria-label', text);
      button.setAttribute('aria-pressed', String(audible));
      wave.toggleAttribute('hidden', !audible);
      slash.toggleAttribute('hidden', audible);
      queuePosition();
    }
    function rewind() { try { video.currentTime = 0; } catch (_) {} }
    function playWith(sound, restart = false, mayFallback = true) {
      const thisRequest = ++requestId;
      video.controls = false;
      video.muted = !sound;
      if (sound) video.removeAttribute('muted');
      if (restart) rewind();
      let play;
      try { play = video.play(); } catch (_) { update(); return; }
      if (!play || !play.then) { update(); return; }
      play.then(() => {
        if (destroyed || thisRequest !== requestId) return;
        if (!video.muted) {
          hasHeardSound = true;
          document.querySelectorAll('video,audio').forEach(other => {
            if (other !== video && !other.muted && !other.paused) other.pause();
          });
        }
        update();
      }).catch(error => {
        if (destroyed || thisRequest !== requestId) return;
        if (error.name === 'NotAllowedError' && sound && mayFallback) {
          playWith(false, restart, false);
        } else {
          update();
        }
      });
      update();
    }
    function start() {
      ++requestId;
      video.pause();
      rewind();
      wantsSound = !savedMute();
      video.muted = !wantsSound;
      hasHeardSound = false;
      pausedByUser = false;
      pausedByOther = false;
      if (reducedMotion.matches || document.hidden) {
        resumeWhenVisible = !reducedMotion.matches;
        update();
        return;
      }
      playWith(wantsSound, true);
    }
    function togglePlayback() {
      if (video.paused) {
        pausedByUser = false;
        pausedByOther = false;
        playWith(!video.muted, false);
      } else {
        ++requestId;
        pausedByUser = true;
        resumeWhenVisible = false;
        video.pause();
      }
      update();
    }
    on(button, 'click', event => {
      event.stopPropagation();
      if (!video.paused && !video.muted) {
        ++requestId;
        wantsSound = false;
        saveMute(true);
        video.muted = true;
        update();
        return;
      }
      wantsSound = true;
      saveMute(false);
      pausedByUser = false;
      pausedByOther = false;
      playWith(true, !hasHeardSound);
    });
    on(shell, 'click', event => {
      if (event.target.closest('button,a')) return;
      togglePlayback();
    });
    on(video, 'keydown', event => {
      if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();
        togglePlayback();
      }
    });
    ['playing', 'pause', 'volumechange', 'error', 'ended'].forEach(name => on(video, name, update));
    on(document, 'play', event => {
      const other = event.target;
      if (other !== video && other instanceof HTMLMediaElement && !other.muted && !video.paused) {
        ++requestId;
        pausedByOther = true;
        resumeWhenVisible = false;
        video.pause();
      }
    }, {capture:true});
    on(document, 'visibilitychange', () => {
      if (document.hidden) {
        resumeWhenVisible = !video.paused;
        ++requestId;
        video.pause();
      } else if (resumeWhenVisible && !pausedByUser && !pausedByOther && !reducedMotion.matches) {
        resumeWhenVisible = false;
        playWith(!video.muted, false);
      }
    });
    on(window, 'pageshow', event => { if (event.persisted) start(); });
    on(window, 'scroll', queuePosition, {passive:true});
    on(window, 'resize', queuePosition, {passive:true});
    on(reducedMotion, 'change', event => {
      if (event.matches) { ++requestId; video.pause(); update(); }
    });
    const controlsObserver = new MutationObserver(() => {
      if (video.controls) { video.controls = false; video.removeAttribute('controls'); }
    });
    controlsObserver.observe(video, {attributes:true, attributeFilter:['controls']});
    const destroy = () => {
      destroyed = true;
      ++requestId;
      video.pause();
      events.abort();
      controlsObserver.disconnect();
      cancelAnimationFrame(frame);
      button.remove();
      description.remove();
      instances.delete(video);
    };
    instances.set(video, {destroy});
    start();
  }
  function init() {
    const config = document.querySelector('[data-mn-showcase-config]');
    if (!config) return;
    document.querySelectorAll('.mnr-workshop__video video').forEach(video => mount(video, config));
  }
  window.mnShowcasePlaybackV3 = {init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    const removesConfig = event.target.querySelector?.('[data-mn-showcase-config]');
    instances.forEach((instance, video) => {
      if (removesConfig || event.target.contains(video)) instance.destroy();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-wall-boring-ad"] && !Shopify.designMode) return;
  try {
    
(() => {
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const smooth = (start, end, value) => {
    const x = clamp((value - start) / (end - start), 0, 1);
    return x * x * (3 - 2 * x);
  };

  document.querySelectorAll('[data-mn-story]').forEach((root) => {
    if (root.dataset.motionReady === 'true') return;
    root.dataset.motionReady = 'true';

    const motion = root.querySelector('[data-mn-motion]');
    const designer = root.querySelector('[data-mn-designer]');
    const designerLinks = root.querySelectorAll('[data-mn-designer-link]');
    if (!motion || !designer) return;

    designerLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        designer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let guidedScroll = false;
    let touchStartY = 0;
    let releaseTimer;

    const stepPositions = () => {
      const pageY = window.scrollY || document.documentElement.scrollTop || 0;
      const viewport = Math.max(1, window.innerHeight);
      const motionTop = pageY + motion.getBoundingClientRect().top;
      const distance = Math.max(1, motion.offsetHeight - viewport);
      const designerTop = pageY + designer.getBoundingClientRect().top;
      return [motionTop, motionTop + distance * 0.72, designerTop];
    };

    const moveOneStep = (direction) => {
      if (guidedScroll || !direction) return;
      const [first, second, third] = stepPositions();
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      if (y < first - 24 || y > third + 24) return;

      let target;
      if (direction > 0) {
        target = y < second - 28 ? second : third;
      } else {
        target = y > second + 28 ? second : first;
      }

      if (Math.abs(target - y) < 18) return;
      guidedScroll = true;
      clearTimeout(releaseTimer);
      window.scrollTo({ top: target, behavior: 'smooth' });
      releaseTimer = setTimeout(() => { guidedScroll = false; }, 720);
    };

    root.addEventListener('wheel', (event) => {
      if (guidedScroll || Math.abs(event.deltaY) < 18) return;
      const [first, , third] = stepPositions();
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      if (y < first - 12 || y >= third - 12) return;
      event.preventDefault();
      moveOneStep(Math.sign(event.deltaY));
    }, { passive: false });

    root.addEventListener('touchstart', (event) => {
      touchStartY = event.touches[0]?.clientY || 0;
    }, { passive: true });

    root.addEventListener('touchend', (event) => {
      const endY = event.changedTouches[0]?.clientY || touchStartY;
      const delta = touchStartY - endY;
      if (Math.abs(delta) < 26) return;
      requestAnimationFrame(() => moveOneStep(Math.sign(delta)));
    }, { passive: true });

    let ticking = false;

    const update = () => {
      ticking = false;
      const rect = motion.getBoundingClientRect();
      const viewport = Math.max(1, window.innerHeight);
      const distance = Math.max(1, motion.offsetHeight - viewport);
      const progress = clamp(-rect.top / distance, 0, 1);

      const sceneOneExit = smooth(0.06, 0.52, progress);
      const sceneTwoEnter = smooth(0.16, 0.66, progress);
      const glow = smooth(0.28, 0.66, progress);

      const sceneOneY = -110 * sceneOneExit;
      const sceneTwoY = 108 * (1 - sceneTwoEnter);

      root.style.setProperty('--mn-s1-y', sceneOneY.toFixed(3) + 'vh');
      root.style.setProperty('--mn-s2-y', sceneTwoY.toFixed(3) + 'vh');
      root.style.setProperty('--mn-s1-copy-y', (-9 * sceneOneExit).toFixed(3) + 'vh');
      root.style.setProperty('--mn-s2-copy-y', (15 * (1 - sceneTwoEnter)).toFixed(3) + 'vh');
      root.style.setProperty('--mn-s1-subject-y', (-4 * sceneOneExit).toFixed(3) + 'vh');
      root.style.setProperty('--mn-s2-subject-y', (18 * (1 - sceneTwoEnter)).toFixed(3) + 'vh');
      root.style.setProperty('--mn-s1-subject-x', (2.5 * sceneOneExit).toFixed(3) + 'vw');
      root.style.setProperty('--mn-s2-subject-x', (-8 * (1 - sceneTwoEnter)).toFixed(3) + 'vw');
      root.style.setProperty('--mn-s1-scale', (1 + .02 * sceneOneExit).toFixed(4));
      root.style.setProperty('--mn-s2-scale', (.92 + .08 * sceneTwoEnter).toFixed(4));
      root.style.setProperty('--mn-glow', glow.toFixed(4));
      root.style.setProperty('--mn-progress', progress.toFixed(4));
    };

    const schedule = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    update();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
